<div> <button mat-icon-button mat-dialog-close class="close-dialog">
        <mat-icon>close</mat-icon>
    </button>
    <h2 mat-dialog-title> Services associated with client: {{clientCode}} </h2>
    <div class="mat-dialog-title-content">
        <div class="scroll-container">
            <mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef>
                        Service Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                        {{item.name}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="alias">
                    <mat-header-cell *matHeaderCellDef>
                        Service Alias (Client's specific service name)
                    </mat-header-cell>
                    <mat-cell *matCellDef="let item">
                        {{item.alias}}
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close> Close </button>
    </div>
</div>